<template>
  <el-result
    icon="warning"
    title="抱歉，企业版、旗舰版及慧经营暂未上线忘记密码功能">
    <template #extra>
      <el-button key="console" type="primary" @click="handleClick">
        跳转至登录页
      </el-button>
    </template>
  </el-result>
</template>
<script lang="ts" setup>
import { Page } from "@/router/router-enum"
import { notifyParentGo } from "@/utils"
const router = useRouter()

const handleClick = () => {
  // 内嵌iframe中
  if (window.parent != window.self) {
    notifyParentGo(Page.SUPPORT_LOGIN);
    return;
  }

  router.push(Page.LOGIN);
};
</script>
